import { ReactElement } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/free-solid-svg-icons';

import { useCart } from '~/lib/cart';

import { currencyWithCents } from '~/lib/format';

export function SumoDayLineItem({ price }: { price?: number }): ReactElement {
  const { cart } = useCart();

  const applied = !!cart?.sd_coupon_applied;

  return (
    <div className="flex">
      <div>
        <FontAwesomeIcon icon={faTag} className="mr-1 text-dollar" />
        <span className="text-sm">
          {applied ? 'Score! 10% off for Sumo Day' : 'Eligible for 10% off'}
        </span>
      </div>
      {!!price && applied && (
        <div className="ml-auto text-sm text-grace line-through">
          {currencyWithCents(price)}
        </div>
      )}
    </div>
  );
}
